import { NgModule } from '@angular/core';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { PhxScrollableDirective } from './phx-scrollable.directive';

@NgModule({
  imports: [ScrollingModule],
  declarations: [PhxScrollableDirective],
  exports: [PhxScrollableDirective]
})
export class PhxScrollableModule { }
